import { createDeletablePermission } from "@/permissions/shared/createDeletablePermission";
import { useMeetingsStore } from "@/stores/meetings.module";

export function useMeetingPermissions() {
  const store = useMeetingsStore();

  const deletable = createDeletablePermission(store);

  return { deletable };
}
